module.exports = __webpack_public_path__ + "images/ReferFriendImage_daa0cae.svg";